import { Component, OnInit, Input } from '@angular/core';
import { SharedService } from '../../../component/shared/shared.service';
import {PromotionCode} from '../model/promotion-code';
import { IMyDpOptions, IMyDateModel } from 'mydatepicker';
import {PromotionCodeService} from '../services/promotion-code.service';
import { DialogAction, ActionMessage } from '../../../shared/enum/dialog-action.enum';
import { AuthServiceService } from '../../../component/service/auth-service.service';
@Component({
  selector: 'app-promotion-code',
  templateUrl: './promotion-code.component.html',
  styleUrls: ['./promotion-code.component.css']
})
export class PromotionCodeComponent implements OnInit {
  
  promotionData: PromotionCode = new PromotionCode(null, '', '', null, '', '', false, '', null, '', '', null, false);
  loading: boolean=false;
  listLoading: boolean = false;
  message: string = '';
  isAdd: boolean = true;
  startDate: any;
  endDate: any;
  parameterOptions: any;
  promotionCodeList: PromotionCode[];
  user: any;
  selectedObject : PromotionCode;
  myDateOptions: IMyDpOptions = {
    // other options...
  dateFormat: 'dd/mm/yyyy',
  disableUntil: {year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate()-1}
};
isSuperAdmin: boolean = false;
isDoctor: boolean = false;
isBDA: boolean = false;
isAssistant: boolean = false;
  constructor(private _sharedService: SharedService, private _srvService: PromotionCodeService, private authService: AuthServiceService) {
    //const dt = new Date();
    //this.startDate =  { date: { year: dt.getFullYear(), month: dt.getMonth() + 1, day: dt.getDate() } };

    if (this.authService.getUserRole() === "1") {
      this.isSuperAdmin = true;
   } else if (this.authService.getUserRole() === "2") {
     this.isDoctor = true;
   } else if (this.authService.getUserRole() === "3") {
    this.isAssistant = true;
  } else if(this.authService.getUserRole() === "4") {
    this.isBDA = true;
  }

    _sharedService.yesEmitted$.subscribe(
      text => {
          if (text.Action === DialogAction.DELETE.toString()  && text.Page === 'PromotionCode') {
            this.delete();
          } else {
              this.clearData();
          }
      });

   }

   onDateChanged(event: IMyDateModel) {
    if (event.date != null && event.date.year !== 0) {
      console.log('event.date', event.date);
      this.promotionData.StartDate = event.date.year + '-' + event.date.month + '-' + event.date.day;
    }
    else{
      //this.message = 'Please select appointment date!'; 
      //this.isErrorMessage = true;
      return;
    }
  }

  onEndDateChanged(event: IMyDateModel){
    if (event.date != null && event.date.year !== 0) {
      console.log('event.date', event.date);
      this.promotionData.EndDate = event.date.year + '-' + event.date.month + '-' + event.date.day;
    }
    else{
      //this.message = 'Please select appointment date!'; 
      //this.isErrorMessage = true;
      return;
    }
  }

  ngOnInit() {
    this.user = JSON.parse(sessionStorage.getItem('User'));
    console.log(this.user);
    this.parameterOptions = [
      {name: 'Appointment', value: 'Appointment', valid: false}
    ];
    this.getPromotionCodeDetail();
  }

  bindParemeterOptions(): void {
    this.parameterOptions = [
      {name: 'Appointment', value: 'Appointment', valid: false}
    ];
  }

  getPromotionCodeDetail(): void {
    this.listLoading = true;
    this._srvService.getPromotionCode(this.user.UserId).subscribe(
      data => {
          this.listLoading = false;
          this.promotionCodeList  = data;
      },
      error => {
          this.listLoading = false;
      }
    );
 }

 editPromoCode(srvEditObject: PromotionCode): void {
  this.isAdd = false;
  this.promotionData = Object.assign(Object.create(srvEditObject), srvEditObject);
  const parameterArr = this.promotionData.Parameter.split(',');
  console.log(this.promotionData);
  const getStartDate = new Date(this.promotionData.StartDate);
  const getEndDate = new Date(this.promotionData.EndDate);
  this.startDate =  { date: { year: getStartDate.getFullYear(), month: getStartDate.getMonth() + 1, day: getStartDate.getDate() } };
  this.endDate = { date: { year: getEndDate.getFullYear(), month: getEndDate.getMonth() + 1, day: getEndDate.getDate() } };
  this.parameterOptions.map((item, index) => {
    parameterArr.map(itemstr => {
        if (item.name === itemstr) {
                item.valid = true;
        }
    });
  });
  console.log(this.parameterOptions);
}

  savePromoCode(): void {
    const selectedOrderIds = this.parameterOptions.filter(v => v.valid === true)
   .map((v, i) => v ? v.name : null);

    console.log(selectedOrderIds);
    console.log(this.parameterOptions);
  if (this.promotionData.Code === '') {
      return;
  }
    this.loading = true;

    if (this.isBDA) {
      const dt = new Date();
      this.promotionData.IsActive = true;
      this.promotionData.StartDate = dt.getFullYear() + '-' + (dt.getMonth() + 1) + '-' + dt.getDate();
      this.promotionData.EndDate = dt.getFullYear() + '-' + (dt.getMonth() + 1) + '-' + dt.getDate();
      this.promotionData.DiscountPercentage = 10;
      this.promotionData.IsBDA = true;
    }

    console.log(this.user);
    this.promotionData.UserId = this.user.UserId;
    this.promotionData.Parameter = selectedOrderIds.join(',');
    this._srvService.data = this.promotionData;
    console.log(this.promotionData);
    if (this.isAdd) {
      this.addPromoCode();
    } else {
      this.updatePromoCode();
    }
}

addPromoCode(): void {
  this._srvService.savePromotionCode().subscribe(data => {
   this.loading = false;
   this.message = 'Promotion Code ' + ActionMessage.SAVESUCCESS.toString();
   this.clearData();
   this.getPromotionCodeDetail();
   this.hideMessage();
 },
 error => {
     this.loading = false;
     if (error.data !== undefined) {
       this.message = error.data;
     } else {
       this.message = JSON.parse(error._body).Message;
     }
     this.hideMessage();
 });
}

updatePromoCode(): void {
  this._srvService.updatePromotionCode().subscribe(data => {
    this.loading = false;
    this.message = 'Promotion Code ' + ActionMessage.UPDATESUCCESS.toString();
    this.clearData();
    this.getPromotionCodeDetail();
    this.hideMessage();
  },
  error => {
      this.loading = false;
      if(error.data !== undefined) {
        this.message = error.data;
      } else {
        this.message = JSON.parse(error._body).Message;
      }
      this.hideMessage();
  });
}

delete() :void {
  this.listLoading = true;
  this._srvService.deletePromotionCode(this.selectedObject).subscribe(data => {
    this.listLoading = false;
    this.message = 'Promotion Code ' + ActionMessage.DEACTIVATE.toString();
    this.clearData();
    this.getPromotionCodeDetail();
    this.hideMessage();
  },
  error=>{
      this.listLoading = false;
      if(error.data !== undefined) {
        this.message = error.data;
      } else {
        this.message = JSON.parse(error._body).Message;
      }
      this.hideMessage();
  });
}

deletePromoCode(org : PromotionCode) :void {
  this.selectedObject = org;
  this._sharedService.emitDialog(true, 'Deactivate', ActionMessage.DEACTIVATE.toString(), true,
  DialogAction.DELETE.toString(), 'PromotionCode' );
}

cancelData(): void {
  if (this.isAdd) {
    this.clearData();
  } else {
    this._sharedService.emitDialog(true, 'Cancel', ActionMessage.CANCEL.toString(),
    true, DialogAction.CANCEL.toString(), 'PromotionCode'  );
  }
}

clearData(): void {
  this.promotionData.Id = null;
  this.promotionData.StartDate = '';
  this.promotionData.EndDate = '';
  this.promotionData.Code = '';
  this.promotionData.Description = '';
  this.promotionData.DiscountAmount = null;
  this.promotionData.DiscountPercentage = null;
  this.promotionData.IsActive = false;
  this.startDate = null;
  this.promotionData.ReferringAgency = '';
  this.promotionData.Address = '';
  this.endDate = null;
  this.bindParemeterOptions();
  this.isAdd = true;
}

hideMessage(): void {
  setTimeout(() => {
    this.message = '';
  }, 1000);
}

  ngAfterViewChecked() {
    this._sharedService.emitChange(false);
 }
 ngOnDestroy() {
    this._sharedService.emitChange(true);
 }
}



// WEBPACK FOOTER //
// ./src/app/section/master/promotion-code/promotion-code.component.ts